export default function mask(obj = {}, properties = []) {
    return properties.reduce((newObj, prop) => {
      newObj[prop] = obj[prop];
      return newObj;
    }, {});
}

